import dayjs from 'utils/dayjs'
import { getEventStructuredData } from 'utils/structuredData'
import { DATE_FORMAT } from '~constants'
import { ArtistProps } from '../../types'

export const createEventStructuredData = (seo: any, artist: ArtistProps, allEvents: any[], hidePricing?: boolean) => {
  if (!allEvents?.length) return {}

  const urlBase = process.env.NEXT_PUBLIC_DOMAIN_URL
  const {
    eventStructuredDataDescription: description,
    eventStructuredDataImage: image,
    eventStructuredDataName: name,
    eventStructuredDataPerformerName: performerName,
    metaDescription
  } = seo || {}

  return allEvents
    .map(item => {
      const event = item?.events?.[0]
      if (!event) return null

      const price = hidePricing || event.price?.min === 0 ? undefined : event.price?.min
      const eventDate = dayjs.tz(event.date_time, event.timezone).format(DATE_FORMAT.DATE_TIMEZONE)

      return getEventStructuredData(
        description || metaDescription,
        image?.url || artist?.calendarEventDetailsImage?.url,
        name || `${artist?.artistName} at Sphere`,
        performerName || artist?.artistName,
        artist?.edpPage?.slug && urlBase ? `${urlBase}${artist.edpPage.slug}` : '',
        price,
        eventDate,
        ''
      )
    })
    .filter(Boolean)
}
